<template>
  <a-layout id="setting">
    <a-page-header
      style="border-bottom: 1px solid #e8e8e8;background-color: white;"
      title="设置"
      :backIcon="false"
    />

    <a-layout>
      <a-layout-sider
        theme="light"
        :collapsed="false"
        :trigger="null"
        collapsible
      >
        <SiderMenu />
      </a-layout-sider>
      <a-layout-content class="setting__info">
        <router-view></router-view>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
// import Header from "./Header.vue";
import SiderMenu from "./layout/SiderMenu";
// import SettingHeader from "./layout/SettingHeader";
export default {
  data() {
    return {
      name: "basic"
    };
  },
  components: {
    SiderMenu
    // Header
  }
};
</script>
<style>
#setting {
  height: 100%;
  width: 100%;
}

.setting__info {
  padding: 4rem 5rem;
  background-color: #fff;
}
</style>
